/* istanbul ignore file */
import { gql } from '@ori/fetching';
export const labels = gql`
  fragment ProductLabels on ProductLabel {
    labelKey
    productLabelDomain
    title
  }
`;
//# sourceMappingURL=labels.js.map